export default __webpack_public_path__ + "static/media/Gum 1.7f4ed522.png";